import { createContext } from 'preact';
const RadioGroupContext = createContext(null);
export default RadioGroupContext;
//# sourceMappingURL=RadioGroupContext.js.map